export default import.meta.ROLLDOWN_FILE_URL_k0j7rkFu2IJCcvroynKGAA